import { createSlice } from "@reduxjs/toolkit";
import { getContainerLogs, bulkDeleteLogs } from "./thunk";

export const initialState = {
  logs: [],
  logsTotal: 0,
  logsPage: 1,
  logsHasMore: false,
  actionCountMap: {},
  priorityCountMap: {},
  conflictedCount: 0,
  negativeFeeDiffCount: 0,
  positiveFeeDiffCount: 0,
  feeDiffSum: 0,
  negativeFeeDiffSum: 0,
  positiveFeeDiffSum: 0,
  topNegativeCompanies: [],
  topPositiveCompanies: [],
  topNegativeUsers: [],
  topPositiveUsers: [],
  isLoading: false,
  isDeleting: false,
  error: null,
};

const logsSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {
    resetLogs: (state) => {
      state.logs = [];
      state.logsTotal = 0;
      state.logsPage = 1;
      state.logsHasMore = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getContainerLogs.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(getContainerLogs.fulfilled, (state, action) => {
      const {
        logs,
        totalCount,
        currentPage,
        totalPages,
        actionCountMap,
        priorityCountMap,
        conflictedCount,
        negativeFeeDiffCount,
        positiveFeeDiffCount,
        feeDiffSum,
        negativeFeeDiffSum,
        positiveFeeDiffSum,
        topNegativeCompanies,
        topPositiveCompanies,
        topNegativeUsers,
        topPositiveUsers,
        append,
      } = action.payload;

      state.logs = append ? [...state.logs, ...(logs || [])] : (logs || []);
      state.logsTotal = totalCount ?? state.logsTotal;
      state.logsPage = currentPage ?? 1;
      state.logsHasMore = currentPage < totalPages;
      state.actionCountMap = actionCountMap ?? state.actionCountMap;
      state.priorityCountMap = priorityCountMap ?? state.priorityCountMap;
      state.conflictedCount = conflictedCount ?? state.conflictedCount;
      state.negativeFeeDiffCount = negativeFeeDiffCount ?? state.negativeFeeDiffCount;
      state.positiveFeeDiffCount = positiveFeeDiffCount ?? state.positiveFeeDiffCount;
      state.feeDiffSum           = feeDiffSum           ?? state.feeDiffSum;
      state.negativeFeeDiffSum   = negativeFeeDiffSum   ?? state.negativeFeeDiffSum;
      state.positiveFeeDiffSum   = positiveFeeDiffSum   ?? state.positiveFeeDiffSum;
      state.topNegativeCompanies = topNegativeCompanies ?? state.topNegativeCompanies;
      state.topPositiveCompanies = topPositiveCompanies ?? state.topPositiveCompanies;
      state.topNegativeUsers     = topNegativeUsers     ?? state.topNegativeUsers;
      state.topPositiveUsers     = topPositiveUsers     ?? state.topPositiveUsers;
      state.isLoading = false;
      state.error = null;
    });

    builder.addCase(getContainerLogs.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload ?? action.error?.message ?? "Алдаа гарлаа";
    });

    builder.addCase(bulkDeleteLogs.pending, (state) => {
      state.isDeleting = true;
    });

    builder.addCase(bulkDeleteLogs.fulfilled, (state, action) => {
      const deletedIds = new Set(action.payload);
      state.logs = state.logs.filter((l) => !deletedIds.has(l._id));
      state.logsTotal = Math.max(0, state.logsTotal - action.payload.length);
      state.isDeleting = false;
    });

    builder.addCase(bulkDeleteLogs.rejected, (state, action) => {
      state.isDeleting = false;
      state.error = action.payload ?? action.error?.message ?? "Устгахад алдаа гарлаа";
    });
  },
});

export const { resetLogs } = logsSlice.actions;
export default logsSlice.reducer;
